import React from "react";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import * as enums from "../constants/enums";
import * as agent from "../agent";
import CreditActive from "./CreditActive";
import CreditClosed from "./CreditClosed";
import PrimaryDivider from "./PrimaryDivider";
import Fade from "@material-ui/core/Fade";
import Preloader from "./Preloader";
import Typography from "@material-ui/core/Typography";

class Credit extends React.Component {

    state = {
        credit: {},
        creditLoaded: false
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const [,,creditId] = this.props.location.pathname.split("/");
        agent.Credit.getById(creditId)
            .then(res => this.setState({ credit: res, creditLoaded: true }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    updateCredit = (credit) => {
        this.setState({ credit })
    }

    render() {
        const { credit, creditLoaded } = this.state;
        const { number, status, type } = credit;
        return (
            <Fade in={true}>
                {creditLoaded ?
                    <React.Fragment>
                        <Typography variant="h4">{enums.Credit.Types[type]} № {number}</Typography>
                        <PrimaryDivider />
                        { ({
                            "ACTIVE": <CreditActive credit={credit} updateCredit={this.updateCredit} />,
                            "CLOSED": <CreditClosed />,
                        })[status] }
                    </React.Fragment>
                    :
                    <Preloader />
                }
            </Fade>
        );
    }
}

export default Credit;



// WEBPACK FOOTER //
// ./src/components/Credit.js